import axios, { AxiosResponse } from 'axios';
import config from '@/../service/project.config.js';
import { CwxBackend } from '@/types/cwxBackend';
import { ApiError, ApiSuccess } from '@/types/commonTypes';

export default {
  async sendLoginForm(
    loginModel: CwxBackend.ILoginViewModel,
    returnUrl: string = ' ',
  ): Promise<CwxBackend.ILoginReplayDto | ApiError> {
    let parameters = {};
    if (returnUrl) {
      parameters = { ReturnUrl: returnUrl };
    }

    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/Account/LoginUser`;
    return axios
      .post(endpointUrl, loginModel, {
        headers: { isDisableAntiforgeryToken: true },
        params: parameters,
      })
      .then((response) => {
        return response.data;
      });
  },

  async sendForgotPasswordForm(
    forgotPasswordModel: CwxBackend.IForgotPasswordViewModel,
  ): Promise<CwxBackend.IResetPasswordReplayDto | ApiError> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/Account/ForgotPasswordForm`;
    return axios
      .post(endpointUrl, forgotPasswordModel, { headers: { isDisableAntiforgeryToken: true } })
      .then((response) => {
        return response.data;
      });
  },

  async sendResetPasswordForm(
    resetPasswordModel: CwxBackend.IResetPasswordViewModel,
  ): Promise<CwxBackend.IResetPasswordReplayDto | ApiError> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/Account/SetNewPassword`;
    return axios
      .post(endpointUrl, resetPasswordModel, { headers: { isDisableAntiforgeryToken: true } })
      .then((response) => {
        return response.data;
      });
  },

  async getLoginPageContent(): Promise<CwxBackend.ILoginViewModel> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/Account/GetLoginPageContent`;
    return axios.get<CwxBackend.ILoginViewModel>(endpointUrl).then((response) => {
      return response.data;
    });
  },

  async getAccountNavigationSettings(
    userId: string,
  ): Promise<CwxBackend.IAccountNavigationSettingsDto> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/Account/GetAccountNavigationSettings?userId=${userId}`;
    return axios.get<CwxBackend.IAccountNavigationSettingsDto>(endpointUrl).then((response) => {
      return response.data;
    });
  },

  async getRegistrationProfile(
    registerEmail: string,
  ): Promise<CwxBackend.IRegisterNewUserProfileDto> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/Account/GetRegistrationProfile`;
    return axios
      .post(
        endpointUrl,
        { registerEmail: registerEmail },
        { headers: { isDisableAntiforgeryToken: true } },
      )
      .then((response) => {
        return response.data;
      });
  },

  async sendRegisterNewUserForm(
    registerViewModel: CwxBackend.IRegisterNewUserDto,
    returnUrl: string = '',
  ): Promise<CwxBackend.IRegisterNewUserReplayDto | ApiError> {
    let parameters = {};
    if (returnUrl) {
      parameters = { returnUrl: returnUrl };
    }
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/Account/RegisterNewUser`;
    return axios
      .post(endpointUrl, registerViewModel, {
        headers: { isDisableAntiforgeryToken: true },
        params: parameters,
      })
      .then((response) => {
        return response.data;
      });
  },

  async activateUserAccount(token: string, userId: string): Promise<ApiSuccess | ApiError> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/Account/ActivateNewUserAccount`;
    return axios
      .post(
        endpointUrl,
        { token: token, userId: userId },
        { headers: { isDisableAntiforgeryToken: true } },
      )
      .then((response) => {
        return response.data;
      });
  },

  async sendUserFeedback(
    feedbackForm: CwxBackend.IFeedbackFormDto,
  ): Promise<AxiosResponse<ApiSuccess | ApiError>> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/Account/SendUserFeedback`;
    return axios.post(endpointUrl, feedbackForm).then((response) => {
      return response;
    });
  },

  async sendGuestUserFeedback(
    guestFeedbackForm: CwxBackend.IGuestFeedbackFormDto,
  ): Promise<AxiosResponse<ApiSuccess | ApiError>> {
    const endpointUrl = `${config.backend}/${config.apiPrefixes.v1}/Account/SendGuestUserFeedback`;
    return axios
      .post(endpointUrl, guestFeedbackForm, { headers: { isDisableAntiforgeryToken: true } })
      .then((response) => {
        return response;
      });
  },
};
